/* Blank apparel size card (nbg2, Justin 2026-10-22) — cart page AND slide-out cart.
   Each .nt-blank-group.nbg2 (snippets/cart-form-page.liquid + cart-form.liquid) carries a data-nbg2 JSON blob
   with its lines; this draws one card per product + color: size pills with the tier price each, and Edit Sizes
   opens a SIZE / PRICE / QTY / TOTAL table for every size of the color, with steppers.
   The helpers below (tier pricing, size list, promo-safe qty split) are the same as the cart page's
   Add/Edit Size modal in sections/main-cart.liquid — that copy only loads on /cart, this one runs everywhere
   the drawer does. Keep the two in step. Styles: assets/nt-blank-card.css. */
(function () {
  'use strict';
  if (window.__ntBlankCard) return;
  window.__ntBlankCard = true;

  function money(c) { return '$' + (c / 100).toFixed(2); }
  var RETAIL_PRICE_MULTIPLIER = 1.96;
  function parseTierPricing(raw) {
    if (!raw) return [];
    var s = String(raw).trim(); if (!s) return [];
    try { var p = JSON.parse(s); if (Array.isArray(p)) s = p.join(','); } catch (e) {}
    return s.split(',').map(function (v) { return parseInt(v.trim(), 10); }).filter(function (n) { return n > 0; });
  }
  function getTierLevel(dollars) {
    if (dollars >= 3800) return 7; if (dollars >= 1750) return 6; if (dollars >= 1000) return 5;
    if (dollars >= 500) return 4; if (dollars >= 250) return 3; if (dollars >= 150) return 2;
    if (dollars >= 99) return 1; return 0;
  }
  /* component-cart.js's cart merge redraws a blank card only when its data or the cart's tier changes */
  window.__ntBlankTierLevel = getTierLevel;

  /* cart total + every line per variant (shares the 2s __ntCartCache with blanks-price-patcher) */
  var _popupCartTotal = 0;
  var _cartLinesByVariant = {};
  function refreshCartPriceMap(cb) {
    var cached = window.__ntCartCache;
    var p = (cached && cached.data && (Date.now() - cached.ts) < 2000)
      ? Promise.resolve(cached.data)
      : fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
          if (cart) window.__ntCartCache = { data: cart, ts: Date.now() };
          return cart;
        });
    p.then(function (cart) {
      _popupCartTotal = cart.total_price || 0;
      _cartLinesByVariant = {};
      cart.items.forEach(function (item) {
        var vid = String(item.variant_id);
        var hasDisc = (item.line_level_discount_allocations || []).length > 0;
        (_cartLinesByVariant[vid] = _cartLinesByVariant[vid] || []).push({ key: item.key, qty: item.quantity, tagged: hasDisc });
      });
      if (cb) cb();
    }).catch(function () { if (cb) cb(); });
  }
  /* new total qty for a variant across its lines, keeping promo-tagged lines intact (main-cart.liquid) */
  function distributeVariantQty(variantId, newQty, updateMap) {
    var lines = _cartLinesByVariant[String(variantId)] || [];
    var tagged = lines.filter(function (l) { return l.tagged; });
    var untagged = lines.filter(function (l) { return !l.tagged; });
    var taggedTotal = tagged.reduce(function (s, l) { return s + l.qty; }, 0);
    if (newQty >= taggedTotal) {
      tagged.forEach(function (l) { updateMap[l.key] = l.qty; });
      var remainder = newQty - taggedTotal;
      if (untagged.length > 0) {
        updateMap[untagged[0].key] = remainder;
        for (var i = 1; i < untagged.length; i++) updateMap[untagged[i].key] = 0;
      } else if (remainder > 0 && tagged.length) {
        updateMap[tagged[0].key] = tagged[0].qty + remainder;
      }
    } else {
      untagged.forEach(function (l) { updateMap[l.key] = 0; });
      var rem = newQty;
      for (var j = 0; j < tagged.length; j++) {
        if (rem >= tagged[j].qty) { updateMap[tagged[j].key] = tagged[j].qty; rem -= tagged[j].qty; }
        else { updateMap[tagged[j].key] = rem; rem = 0; }
      }
    }
  }
  /* every size of one color: Storefront API (has the tier_pricing metafield), get_handle view as fallback */
  var _sfToken = 'f0da551a7e5dc4391d942f1bd786e8b9';
  var _sfCache = {};
  function variantsFromStorefrontApi(handle, color, cb) {
    var pick = function (all) { return all.filter(function (v) { return v.color === String(color).trim(); }); };
    if (_sfCache[handle]) { cb(pick(_sfCache[handle])); return; }
    var all = [];
    function fetchPage(cursor) {
      var after = cursor ? ', after:"' + cursor + '"' : '';
      var query = '{ product(handle: "' + handle + '") { variants(first:250' + after + ') { pageInfo { hasNextPage endCursor } edges { node { id availableForSale selectedOptions { name value } price { amount } metafield(namespace:"custom", key:"tier_pricing") { value } } } } } }';
      fetch('https://transferss.myshopify.com/api/2025-01/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': _sfToken },
        body: JSON.stringify({ query: query })
      }).then(function (r) { return r.json(); }).then(function (d) {
        if (!d.data || !d.data.product) { cb([]); return; }
        var vs = d.data.product.variants;
        vs.edges.forEach(function (e) {
          var n = e.node, vc = '', sz = '';
          n.selectedOptions.forEach(function (o) { if (o.name === 'Color') vc = o.value; if (o.name === 'Size') sz = o.value; });
          all.push({ id: n.id.replace('gid://shopify/ProductVariant/', ''), size: sz, color: vc, price: Math.round(parseFloat(n.price.amount) * 100), available: n.availableForSale, tierPricing: n.metafield ? n.metafield.value : null });
        });
        if (vs.pageInfo.hasNextPage) fetchPage(vs.pageInfo.endCursor);
        else { _sfCache[handle] = all; cb(pick(all)); }
      }).catch(function () { cb([]); });
    }
    fetchPage(null);
  }
  function variantsFromGetHandle(handle, color, cb) {
    fetch('/products/' + handle + '?view=get_handle&variant=' + encodeURIComponent(color))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data.sizes || '';
        if (!html || html.length < 20) { cb([]); return; }
        var doc = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
        var out = [];
        doc.querySelectorAll('input.itemQuantity').forEach(function (inp) {
          var parts = (inp.getAttribute('data-label') || '').trim().split(' / ');
          out.push({ id: inp.getAttribute('data-id'), size: parts[1] || parts[0], price: parseInt(inp.getAttribute('data-price'), 10) || 0, available: true, tierPricing: null });
        });
        cb(out);
      }).catch(function () { cb([]); });
  }

  /* ── Blank apparel size card (nbg2, Justin 2026-10-22) ──
     Draws one card per blank product + color from the group's data-nbg2 JSON (snippets/cart-form-page.liquid):
     size pills with the tier price each, Edit Sizes → SIZE / PRICE / QTY / TOTAL table for EVERY size of the
     color (variantsFromStorefrontApi, same source as the Add/Edit Size modal). Steppers re-price live with the
     virtual cart total (same maths as refreshPopupTierPrices), then commit after a short pause through
     distributeVariantQty (promo-split lines stay intact) / cart add, and refresh the cart silently. */
  var _nbgOpen = {};      /* group key → table open */
  var _nbgFocus = {};     /* group key → bring the table into view once it draws */
  var _nbgEdits = {};     /* group key → { variantId: qty } not yet saved */
  var _nbgBusy = {};
  var _nbgCartTotal = null;

  function nbgData(g) {
    var el = g.querySelector('script[data-nbg2]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function nbgEsc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* the cart's lines for this card, merged per variant (a promo can split one variant into several lines) */
  function nbgVariants(d) {
    var map = {}, order = [];
    (d.lines || []).forEach(function (l) {
      var k = String(l.v);
      if (!map[k]) { map[k] = { v: k, s: l.s, b: l.b, tp: l.tp, q: 0, free: 0, f: 0 }; order.push(k); }
      map[k].q += l.q;
      map[k].f += l.f;
      if (l.f <= 0) map[k].free += l.q;
    });
    var sizes = (d.sizes || []).map(function (x) { return String(x); });
    order.sort(function (a, b) {
      var ia = sizes.indexOf(map[a].s), ib = sizes.indexOf(map[b].s);
      return (ia < 0 ? 999 : ia) - (ib < 0 ? 999 : ib);
    });
    return order.map(function (k) { return map[k]; });
  }
  /* Price = what the cart charges. A size already in the cart shows its line's per-unit price (the
     volume discount is in final_line_price only when it applies); a size added here isn't a cart line
     yet and is added without `_tp`, so it charges the base price. No tier math of our own — it showed
     prices checkout didn't charge. */
  function nbgUnit(r, base) {
    if (!r) return base;
    var paid = r.q - r.free;
    return paid > 0 ? Math.round(r.f / paid) : r.b;
  }

  function nbgRender(g) {
    var d = nbgData(g);
    if (!d) return;
    var key = g.getAttribute('data-group-key') || '';
    var vars = nbgVariants(d);
    var rows = {};
    vars.forEach(function (r) { rows[r.v] = r; });
    var edits = _nbgEdits[key] || {};
    var qtyOf = function (r) { return edits[r.v] != null ? edits[r.v] : r.q; };

    var items = 0, total = 0, retail = 0, pills = '';
    vars.forEach(function (r) {
      var q = qtyOf(r);
      items += q;
      if (q <= 0) return;
      var unit = nbgUnit(r, r.b);
      var paid = Math.max(0, q - Math.min(r.free, q));
      /* unedited size: the cart's exact line totals (one variant can sit on lines at different
         prices, e.g. with and without the volume discount, so unit × qty would round off) */
      total += q === r.q ? r.f : unit * paid;
      retail += (r.tp ? Math.round(unit * RETAIL_PRICE_MULTIPLIER) : r.b) * q;
      pills += '<span class="nbg2-pill"><span class="nbg2-pill__tag"><b>' + nbgEsc(r.s || '—') + '</b> &times; ' + q + '</span><span class="nbg2-pill__ea"><span class="nbg2-ea">' + money(unit) + '</span> ea</span></span>';
    });
    /* sizes added in the table that aren't cart lines yet */
    Object.keys(edits).forEach(function (vid) {
      if (rows[vid] || !(edits[vid] > 0)) return;
      var sv = (_nbgSizeCache[key] || []).filter(function (x) { return String(x.id) === vid; })[0];
      if (!sv) return;
      var unit = nbgUnit(null, sv.price);
      items += edits[vid];
      total += unit * edits[vid];
      retail += (sv.tierPricing ? Math.round(unit * RETAIL_PRICE_MULTIPLIER) : sv.price) * edits[vid];
      pills += '<span class="nbg2-pill"><span class="nbg2-pill__tag"><b>' + nbgEsc(sv.size) + '</b> &times; ' + edits[vid] + '</span><span class="nbg2-pill__ea"><span class="nbg2-ea">' + money(unit) + '</span> ea</span></span>';
    });

    var open = !!_nbgOpen[key];
    /* Update Sizes stays grey until a size differs from what's in the cart */
    var dirty = Object.keys(edits).some(function (vid) { return edits[vid] !== (rows[vid] ? rows[vid].q : 0); });
    var card = g.querySelector(':scope > .nbg2-card');
    if (!card) {
      card = document.createElement('div');
      card.className = 'nbg2-card';
      g.insertBefore(card, g.firstChild);
    }
    card.classList.toggle('is-open', open);
    var html =
      '<div class="nbg2-head">' +
        '<div class="nbg2-thumb">' + (d.thumb ? '<img src="' + nbgEsc(d.thumb) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="nbg2-info">' +
          '<a class="nbg2-title" href="' + nbgEsc(d.url) + '">' + nbgEsc(d.title) + '</a>' +
          '<div class="nbg2-meta">Color: <strong>' + nbgEsc(String(d.color || '').toLowerCase()) + '</strong> &middot; ' + items + (items === 1 ? ' item' : ' items') + '</div>' +
          '<div class="nbg2-pills">' + pills + '<button type="button" class="nbg2-edit" data-nbg2-toggle>' + (open ? 'Hide size breakdown<span class="nbg2-caret">&#9650;</span>' : 'Edit Sizes<span class="nbg2-caret">&#9660;</span>') + '</button></div>' +
        '</div>' +
        '<div class="nbg2-price">' + (retail > total ? '<del>' + money(retail) + '</del>' : '') + '<strong>' + money(total) + '</strong>' +
        /* remove this color: the design cards' master X (handler in assets/nt-cart-actions.js) */
        '<button type="button" class="nt-dg-remove-all nbg2-x" data-nt-remove-keys="' + nbgEsc((d.lines || []).map(function (l) { return l.k; }).join(',')) + '" title="Remove this color" aria-label="Remove ' + nbgEsc(d.title + ' ' + String(d.color || '').toLowerCase()) + '"></button></div>' +
      '</div>' +
      (open
        ? '<div class="nbg2-table" data-nbg2-table><div class="nbg2-loading">Loading sizes…</div></div>' +
          '<div class="nbg2-confirm-wrap"><button type="button" class="nbg2-confirm" data-nbg2-confirm' + (_nbgBusy[key] || !dirty ? ' disabled' : '') + '>' + (_nbgBusy[key] ? 'Saving…' : 'Update Sizes') + '</button></div>'
        : '');
    /* redraw only what changed: identical markup is left alone, and a change is merged in (component-cart.js
       morphCart) so the thumbnail and untouched text stay put instead of the whole card blinking */
    if (card.__nbgHtml !== html) {
      if (typeof window.morphCart === 'function' && card.firstChild) {
        var fresh = document.createElement('div');
        fresh.innerHTML = html;
        window.morphCart(card, fresh);
      } else {
        card.innerHTML = html;
      }
      card.__nbgHtml = html;
    }
    g.classList.add('nbg2-on');
    card.classList.toggle('is-saving', !!_nbgBusy[key]);
    if (open) nbgTable(g, d, key, rows);
    nbgEditState();
  }
  /* while a size table is open, Checkout hides in the slide-out cart and on phone cart pages (CSS) */
  function nbgEditState() {
    var b = document.body;
    if (!b) return;
    b.classList.toggle('nbg2-edit-drawer', !!document.querySelector('#site-cart-sidebar .nbg2-card.is-open'));
    b.classList.toggle('nbg2-edit-page', !!document.querySelector('.nbg2-card.is-open:not(#site-cart-sidebar .nbg2-card)'));
  }

  /* snippets/theme-symbols.liquid 'minus' / 'plus' */
  var NBG_MINUS = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.0566 6.5V7.5H0.0566406L0.0566407 6.5L13.0566 6.5Z" fill="black"/></svg>';
  var NBG_PLUS = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.05664 0.5H7.05664V13.5H6.05664V0.5Z" fill="black"/><path d="M13.0566 6.5V7.5H0.0566406L0.0566407 6.5L13.0566 6.5Z" fill="black"/></svg>';
  var _nbgSizeCache = {};
  function nbgTable(g, d, key, rows) {
    function draw(list) {
      var box = g.querySelector('[data-nbg2-table]');
      if (!box) return;
      if (!list.length) { box.innerHTML = '<div class="nbg2-loading">Sizes could not be loaded. <a href="' + nbgEsc(d.url) + '">Open the product</a></div>'; return; }
      var edits = _nbgEdits[key] || {};
      var html = '<div class="nbg2-row nbg2-row--head"><span>Size</span><span>Price</span><span>Qty</span><span>Total</span></div>';
      list.forEach(function (v) {
        var vid = String(v.id), r = rows[vid];
        var q = edits[vid] != null ? edits[vid] : (r ? r.q : 0);
        var soldOut = !v.available && !r;
        var unit = nbgUnit(r, v.price);
        html += '<div class="nbg2-row' + (soldOut ? ' is-soldout' : '') + '" data-nbg2-vid="' + vid + '">' +
          '<span class="nbg2-size">' + nbgEsc(v.size) + '</span>' +
          '<span class="nbg2-unit"><span class="nbg2-ea">' + money(unit) + '</span> ea</span>' +
          /* same markup + theme classes as the cart lines' qty control (cart-page-item.liquid), minus the
             product-quantity / cart-product-quantity custom elements, which would commit each click to the cart */
          '<span class="nbg2-step cart-item__actions"><span class="product-quantity quantity-selector-holder"><span class="nbg2-qtybox">' +
            /* the − greys out at 0, like the transfer lines at their 1 (Owen 2026-10-29) */
            '<button type="button" class="qty-button qty-minus' + (!soldOut && q <= 0 ? ' disabled' : '') + '" data-nbg2-step="-1" aria-label="Decrease ' + nbgEsc(v.size) + '"' + (soldOut ? ' disabled' : (q <= 0 ? ' aria-disabled="true"' : '')) + '>' + NBG_MINUS + '</button>' +
            /* a text box with the number keypad, not type=number: a number field won't hold a select-all, so a click then a
               digit typed in front of the old value (2 -> 52) instead of replacing it (Justin 2026-10-23, Ninja Patches) */
            '<input type="text" inputmode="numeric" pattern="[0-9]*" autocomplete="off" value="' + q + '" class="qty-selector product__quantity" aria-label="' + nbgEsc(v.size) + ' quantity" data-nbg2-qty' + (soldOut ? ' disabled' : '') + '>' +
            '<button type="button" class="qty-button qty-plus" data-nbg2-step="1" aria-label="Increase ' + nbgEsc(v.size) + '"' + (soldOut ? ' disabled' : '') + '>' + NBG_PLUS + '</button>' +
          '</span></span></span>' +
          '<span class="nbg2-line">' + (soldOut ? 'Sold out' : (q > 0 ? money(r && q === r.q ? r.f : unit * q) : '&mdash;')) + '</span>' +
        '</div>';
      });
      box.innerHTML = html;
      /* just opened: bring this card's size table into view (scroll-margin in the CSS clears the sticky header) */
      if (_nbgFocus[key]) {
        delete _nbgFocus[key];
        var card = g.querySelector('.nbg2-card');
        if (card) card.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
    if (_nbgSizeCache[key]) { draw(_nbgSizeCache[key]); return; }
    variantsFromStorefrontApi(d.handle, d.color, function (list) {
      var go = function (l) { _nbgSizeCache[key] = l; nbgRender(g); };
      if (list.length) { go(list); return; }
      variantsFromGetHandle(d.handle, d.color, go);
    });
  }

  function nbgRenderAll() {
    document.querySelectorAll('.nt-blank-group.nbg2').forEach(nbgRender);
  }
  function nbgRefreshTotals() {
    refreshCartPriceMap(function () { _nbgCartTotal = _popupCartTotal; nbgRenderAll(); });
  }

  function nbgSet(g, vid, q) {
    var key = g.getAttribute('data-group-key') || '';
    q = Math.max(0, parseInt(q, 10) || 0);
    (_nbgEdits[key] = _nbgEdits[key] || {})[vid] = q;
    nbgRender(g);
  }
  /* Confirm: save this card's edits, close its table, refresh the cart */
  function nbgSave(g, key) {
    if (_nbgBusy[key]) return;
    var edits = _nbgEdits[key];
    if (!edits || !Object.keys(edits).length) { _nbgOpen[key] = false; nbgRender(g); return; }
    _nbgBusy[key] = true;
    nbgRender(g);
    /* fresh line map first — distributeVariantQty needs the current split of each variant's lines */
    refreshCartPriceMap(function () {
      var sent = {};
      var updates = {}, adds = [];
      Object.keys(edits).forEach(function (vid) {
        sent[vid] = edits[vid];
        if (_cartLinesByVariant[vid]) distributeVariantQty(vid, edits[vid], updates);
        else if (edits[vid] > 0) adds.push({ id: Number(vid), quantity: edits[vid] });
      });
      var post = function (url, body) {
        return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
      };
      var chain = Promise.resolve();
      if (Object.keys(updates).length) chain = chain.then(function () { return post('/cart/update.js', { updates: updates }); });
      if (adds.length) chain = chain.then(function () { return post('/cart/add.js', { items: adds }); });
      chain.then(function () {
        /* drop what was saved; anything typed meanwhile stays queued */
        var cur = _nbgEdits[key] || {};
        Object.keys(sent).forEach(function (vid) { if (cur[vid] === sent[vid]) delete cur[vid]; });
        _nbgBusy[key] = false;
        _nbgOpen[key] = false;
        window.__ntCartCache = null;
        if (typeof window.refreshCart === 'function') window.refreshCart('notOpen');
        else location.reload();
      }).catch(function () {
        _nbgBusy[key] = false;
        nbgRender(g);
        if (typeof window.refreshCart === 'function') window.refreshCart('notOpen');
        if (window.toast) window.toast('Cart', 'Sorry, that size could not be updated. Please try again.', 'red');
      });
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nbg2-toggle]');
    if (t) {
      var g = t.closest('.nt-blank-group.nbg2');
      var key = g.getAttribute('data-group-key') || '';
      _nbgOpen[key] = !_nbgOpen[key];
      if (_nbgOpen[key]) _nbgFocus[key] = true;
      else delete _nbgEdits[key];   /* closed without Confirm: drop the changes */
      nbgRender(g);
      if (!_nbgOpen[key] && g.getBoundingClientRect().top < 0) g.scrollIntoView({ block: 'start', behavior: 'smooth' });
      return;
    }
    var cf = e.target.closest('[data-nbg2-confirm]');
    if (cf) { var gc = cf.closest('.nt-blank-group.nbg2'); nbgSave(gc, gc.getAttribute('data-group-key') || ''); return; }
    var st = e.target.closest('[data-nbg2-step]');
    if (st) {
      var row = st.closest('[data-nbg2-vid]');
      var inp = row.querySelector('[data-nbg2-qty]');
      nbgSet(st.closest('.nt-blank-group.nbg2'), row.getAttribute('data-nbg2-vid'), (parseInt(inp.value, 10) || 0) + Number(st.getAttribute('data-nbg2-step')));
    }
  });
  /* pressing Update Sizes or a stepper blurs a typed field first: record that edit WITHOUT re-rendering, or
     the re-render swaps the control out from under the pointer and the click never lands. Pressing another
     qty field re-renders as usual, then focus moves to that field's new copy. */
  var _nbgHold = null, _nbgNext = null;
  document.addEventListener('pointerdown', function (e) {
    _nbgHold = e.target.closest('[data-nbg2-confirm], [data-nbg2-step]') ? { g: null } : null;
    var q = e.target.closest('[data-nbg2-qty]');
    _nbgNext = q ? q.closest('[data-nbg2-vid]').getAttribute('data-nbg2-vid') : null;
  }, true);
  /* cleared after the click, not on pointerup: on touch, pointerup fires before mousedown/blur/change */
  function nbgRelease() {
    var h = _nbgHold;
    _nbgHold = null;
    _nbgNext = null;
    if (h && h.g) setTimeout(function () { nbgRender(h.g); }, 0);
  }
  document.addEventListener('click', nbgRelease, true);
  document.addEventListener('pointercancel', nbgRelease, true);
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-nbg2-qty]');
    if (!inp) return;
    var g = inp.closest('.nt-blank-group.nbg2'), vid = inp.closest('[data-nbg2-vid]').getAttribute('data-nbg2-vid');
    if (_nbgHold) {
      var key = g.getAttribute('data-group-key') || '';
      (_nbgEdits[key] = _nbgEdits[key] || {})[vid] = Math.max(0, parseInt(inp.value, 10) || 0);
      _nbgHold.g = g;
      return;
    }
    nbgSet(g, vid, inp.value);
    var next = _nbgNext && _nbgNext !== vid && g.querySelector('[data-nbg2-vid="' + _nbgNext + '"] [data-nbg2-qty]');
    if (next) next.focus();
  });
  /* clicking into a size's quantity selects the number EVERY time, so typing replaces it (Justin 2026-10-23, Ninja Patches):
     on focus (click, tap or Tab) and on every later click into a box that already has focus — a click there drops the
     selection to a caret, so it is put back; a drag that selects part of the number is left alone */
  /* a typed qty doesn't re-render the table: keep its − in step (greyed at 0) */
  document.addEventListener('input', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('[data-nbg2-qty]')) return;
    var m = inp.parentNode && inp.parentNode.querySelector('.qty-minus');
    if (!m || m.disabled) return;
    var at = (parseInt(inp.value, 10) || 0) <= 0;
    m.classList.toggle('disabled', at);
    if (at) m.setAttribute('aria-disabled', 'true'); else m.removeAttribute('aria-disabled');
  });
  function nbgSelAll(inp) { try { inp.setSelectionRange(0, String(inp.value || '').length); } catch (x) { try { inp.select(); } catch (y) {} } }
  document.addEventListener('focusin', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('[data-nbg2-qty]')) return;
    inp.__nbgSelUp = true;
    setTimeout(function () { nbgSelAll(inp); }, 0);
  });
  document.addEventListener('mouseup', function (e) {
    var inp = e.target;
    if (!inp || !inp.matches || !inp.matches('[data-nbg2-qty]')) return;
    if (inp.__nbgSelUp) { inp.__nbgSelUp = false; e.preventDefault(); nbgSelAll(inp); return; }   /* Safari drops the focus selection on this mouseup */
    if (inp.selectionStart === inp.selectionEnd) { e.preventDefault(); nbgSelAll(inp); }
  });
  /* …and once more on click, for a browser that puts the caret back after the mouseup */
  document.addEventListener('click', function (e) {
    var inp = e.target;
    if (inp && inp.matches && inp.matches('[data-nbg2-qty]') && inp.selectionStart === inp.selectionEnd) nbgSelAll(inp);
  });
  /* Update Sizes lights up while typing (change only fires on blur); no re-render, so the field keeps focus */
  document.addEventListener('input', function (e) {
    var inp = e.target.closest('[data-nbg2-qty]');
    if (!inp) return;
    /* digits only (the box is a text field so it can hold the select-all) */
    var clean = String(inp.value || '').replace(/\D/g, '').slice(0, 4);
    if (clean !== inp.value) inp.value = clean;
    var g = inp && inp.closest('.nt-blank-group.nbg2');
    var btn = g && g.querySelector('[data-nbg2-confirm]');
    var d = btn && nbgData(g);
    if (!d || _nbgBusy[g.getAttribute('data-group-key') || '']) return;
    var cart = {};
    nbgVariants(d).forEach(function (r) { cart[r.v] = r.q; });
    btn.disabled = !Array.prototype.some.call(g.querySelectorAll('[data-nbg2-vid]'), function (row) {
      var q = row.querySelector('[data-nbg2-qty]');
      return q && Math.max(0, parseInt(q.value, 10) || 0) !== (cart[row.getAttribute('data-nbg2-vid')] || 0);
    });
  });
  /* cart forms re-render their HTML after every change (component-cart.js refreshCart / qty updates) and the
     drawer's form can arrive later: draw any group that has no card yet, then re-price once /cart.js is back */
  var _nbgQueued = false;
  function nbgScan() {
    _nbgQueued = false;
    nbgEditState();   /* a removed card must not leave Checkout hidden */
    if (!document.querySelector('.nt-blank-group.nbg2:not(.nbg2-on)')) return;
    document.querySelectorAll('.nt-blank-group.nbg2:not(.nbg2-on)').forEach(nbgRender);
    nbgRefreshTotals();
  }
  new MutationObserver(function () {
    if (_nbgQueued) return;
    _nbgQueued = true;
    requestAnimationFrame(nbgScan);
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', nbgScan); else nbgScan();
})();
